import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { PageBanner } from "../components/PageBanner";
import { ValuesMarquee } from "../components/ValuesMarquee";
import { CTABand } from "../components/CTABand";
import { WhyChoose } from "../components/home/WhyChoose";

export default function WhyChoosePage() {
  return (
    <div data-testid="why-choose-page">
      <Header />
      <main>
        <PageBanner
          testId="why-choose-banner"
          eyebrow="The BMS Difference"
          title="Why Choose Us"
          description="Choosing a care provider is one of the most important decisions a family can make. Here is what sets BMS Health Care Services apart."
        />
        <WhyChoose />
        <ValuesMarquee />
        <CTABand />
      </main>
      <Footer />
    </div>
  );
}
